/*
 * @Author: edvardchen
 * @Date:   2016-12-08 14:24:48
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:20:13
 */

// @flow
import _ from 'lodash';
declare var __CLIENT__: boolean;
declare var __SERVER__: boolean;

// eslint-disable-next-line import/no-mutable-exports
let config = {};
if (__SERVER__) {
  config = _.get(global.TAF_CONFIG, 'isomorphic');
}

if (__CLIENT__) {
  config = window.CONSTANTS || {};
}
export default config;
